import { computed } from 'vue';

import { convertToUnit, propsFactory } from '@components/utils';

import type { PropType, ComputedRef } from 'vue';

export interface IDimensionsProps {
  height: number | string;
  maxHeight: number | string;
  maxWidth: number | string;
  minHeight: number | string;
  minWidth: number | string;
  width: number | string;
}

export interface IUseDimensions {
  dimensionsStyles: ComputedRef<Record<string, any>>;
}

export const makeDimensionProps = propsFactory(
  {
    /**
     * Высота
     */
    height: {
      type: [Number, String] as PropType<number | string>,
      default: ''
    },
    /**
     * Ширина
     */
    width: {
      type: [Number, String] as PropType<number | string>,
      default: ''
    },
    /**
     * Максимальная высота
     */
    maxHeight: {
      type: [Number, String] as PropType<number | string>,
      default: ''
    },
    /**
     * Максимальная ширина
     */
    maxWidth: {
      type: [Number, String] as PropType<number | string>,
      default: ''
    },
    /**
     * Минимальная высота
     */
    minHeight: {
      type: [Number, String] as PropType<number | string>,
      default: ''
    },
    /**
     * Минимальная ширина
     */
    minWidth: {
      type: [Number, String] as PropType<number | string>,
      default: ''
    }
  },
  'dimensions'
);

export function useDimensions(props: IDimensionsProps): IUseDimensions {
  const dimensionsStyles = computed(() => ({
    height: convertToUnit(props.height),
    maxHeight: convertToUnit(props.maxHeight),
    maxWidth: convertToUnit(props.maxWidth),
    minHeight: convertToUnit(props.minHeight),
    minWidth: convertToUnit(props.minWidth),
    width: convertToUnit(props.width)
  }));

  return { dimensionsStyles };
}
